module.exports = __webpack_public_path__ + "img/5.d471b9d7.jpg";